import { library } from '@fortawesome/fontawesome-svg-core';

import { fontAwesomeIcons } from './config';

export default function configureFontAwesome() {
  library.add(...fontAwesomeIcons);
}
